<template>
  <div>
    <v-layout class="text-xs-right">
    <v-btn v-if="this.data.btnType === 'icon'" :disabled="!this.enableDocumentItemAdd()"
    icon :color="ui.bkgdColor" @click="openRoleAssign()">
      <v-icon :color="ui.btnColor"> person_add_alt_1 </v-icon>
    </v-btn>
    <v-btn v-else flat :color="ui.btnColor" @click="openRoleAssign()"
    :disabled="!this.enableDocumentItemAdd()">
      <v-icon :color="ui.btnColor">
        person_add_alt_1
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-icon left color="wplblue0"> search </v-icon>
          <span :class="ui.textTitle">
            Search Role
          </span>
        </v-card-title>
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field v-model="search.title"
                    label="user name" prepend-icon="person_add_alt_1">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="data.role.user.uname !== ''">
                <v-flex xs12 md12>
                  <v-text-field readonly
                    :label="data.role.user.uname" prepend-icon="person_remove_alt_1">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="this.getSearchResults !== null">
                <v-layout row class="mr-3 ml-3">
                  <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
                    <v-data-table
                    :headers="headers"
                    :items="getSearchResults"
                    class="elevation-1"
                    :total-items=this.maxRows
                    :hide-actions=this.hideActions
                    >
                     <template slot="items" slot-scope="props">
                       <td class="text-xs-left">
                         {{ props.item.char.utitle }}
                       </td>
                       <td class="text-xs-left">
                         {{props.item.char.uemail}}
                       </td>
                       <td class="text-xs-right">
                         <v-btn :color="ui.btnColor" small icon dark
                          :disabled="false"
                          @click="assignRole(props.item)"
                        >
                          <v-icon> person </v-icon>
                        </v-btn>
                       </td>
                     </template>
                   </v-data-table>
                 </v-flex>
                </v-layout>
              </div>
           </v-container>
           <v-layout  row>
             <v-btn
             class="hidden-xs-only"
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              >
               <v-icon left> exit_to_app </v-icon>
               Close
             </v-btn>
             <v-btn
             class="hidden-sm-and-up"
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              >
               <v-icon> exit_to_app </v-icon>
             </v-btn>
             <v-btn
              class="hidden-xs-only"
              @click="resetUserRole()"
              :color="ui.btnColor"
              flat
              >
               <v-icon left> person_remove </v-icon>
               Reset
             </v-btn>
             <v-btn
              class="hidden-sm-and-up"
              @click="resetUserRole()"
              :color="ui.btnColor"
              flat
              >
               <v-icon> person_remove </v-icon>
             </v-btn>
             <v-spacer/>
             <div v-if="this.enableSpinBtnSearch === false">
               <v-btn
                 flat
                 dark
                 class="hidden-xs-only"
                 :color="ui.btnColor"
                 :disabled="this.search.title === ''"
                 @click="searchUserforRole(search)">
                 <v-icon left>search</v-icon>
                 search
               </v-btn>
               <v-btn
                 flat
                 dark
                 class="hidden-sm-and-up"
                 :color="ui.btnColor"
                 :disabled="this.search.title === ''"
                 @click="searchUserforRole(search)">
                 <v-icon>search</v-icon>
               </v-btn>
             </div>
             <div v-else>
               <BtnSpin :btnSpec="btnInfo1"/>
             </div>
          </v-layout>
         </v-form>
    </v-card>

    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import role from "@/data/forms/mixins/role.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import search from "@/data/search/mixins/search.js";
import actionFunctions from "@/business/actions/mixins/actionFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";

export default {
  // eslint-disable-next-line
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  // eslint-disable-next-line
  mixins: [
    role,
    search,
    actionFunctions,
    apptheme,
    dataSources,
    docRevsModFunctions,
    documentFunctions
    // rolesFormValidation
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinBtnSearch: false,
      maxRows: -1,
      hideActions: true,
      barMovement: false,
      search: {
        id: "", // id for search
        title: "", // title for search
        dbs: "" // data base source
      },
      headers: [
        { text: "name", sortable: false },
        { text: "email", sortable: false },
        { text: "", sortable: false }
      ],
      enableSpinner: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        type: "icon"
      }
    };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getRolesList",
      "getRolesListCounter",
      "getDetail",
      "getSearchResults",
      "getRoleAssigneeDIDCurrent",
      "getRoleAssigneeDIDPrevious"
    ]),
    btnColor() {
      if (this.getCurrentPage === "/riskedit") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    openRoleAssign() {
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.$refs.form.reset();
      // Define search
      this.$store.dispatch("changeSearchResults", null);
      // Action Assignee
      if (this.getDetail.basic.tag === "B3") {
        let assignee = this.getRolesList[0].user.udid;
        this.$store.dispatch("changeRoleAssigneeDIDCurrent", assignee);
        this.$store.dispatch("changeRoleAssigneeDIDPrevious", assignee);
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    closeModal() {
      this.dialog = false;
    },
    searchUserforRole() {
      this.enableSpinBtnSearch = true;
      this.search.dbs = this.defineDataSourceFromTag("G4");
      // console.log("SEARCH ROLE");
      // console.log(this.search);
      this.searchUserRoleAssign(this.search);
    },
    refreshList() {
      let store = "changeRolesListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getRolesListCounter + 1);
      this.$store.dispatch(store, this.getRolesListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // parts removed.
      this.dialog = false;
    },
    assignRole(u) {
      var tempRolesList = this.getRolesList;
      // assign new role
      var tempRoleUser = this.roleUser;
      tempRoleUser.uname = u.char.utitle;
      tempRoleUser.uemail = u.char.uemail;
      tempRoleUser.udid = u.char.udid;

      // look for idi and updat new name
      for (let i = 0; i < tempRolesList.length; i++) {
        if (tempRolesList[i].basic.idi === this.data.role.basic.idi) {
          tempRolesList[i].user = tempRoleUser;
        }
      }
      this.saveDocumentRevMod(4.34); // Role updated
      this.$store.dispatch("changeRolesList", tempRolesList);
      this.$store.dispatch("changeRoleAssigneeDIDCurrent", tempRoleUser.udid);
      this.refreshList();
    },
    resetUserRole() {
      let did = this.data.role.basic.did;
      var tempRolesList = this.getRolesList;
      // assign new role
      var tempRoleUser = this.roleUser;
      tempRoleUser.uname = "";
      tempRoleUser.uemail = "";
      tempRoleUser.udid = "";
      for (let i = 0; i < tempRolesList.length; i++) {
        if (tempRolesList[i].basic.did === did) {
          tempRolesList[i].user = tempRoleUser;
        }
      }
      this.saveDocumentRevMod(4.34); // Role updated
      this.$store.dispatch("changeRolesList", tempRolesList);
      this.$store.dispatch("changeRoleAssigneeDIDCurrent", "");
      this.refreshList();
    }
  }
};
</script>
